const INVALID_CHARS = ["<", ">", ":", '"', "/", "\\", "|", "?", "*"];

// File eventual sync/download to user machine (many run Windows).
// If file save as "CON" or "CON.txt" locally, Windows refuse/corrupt.
// Rule protect against that edge case even though backend/S3 storage itsel
// https://help.interfaceware.com/v6/windows-reserved-file-names
// mac don't have
const RESERVED_NAMES = new Set([
  "CON",
  "PRN",
  "AUX",
  "NUL",
  "COM1",
  "COM2",
  "COM3",
  "COM4",
  "COM5",
  "COM6",
  "COM7",
  "COM8",
  "COM9",
  "LPT1",
  "LPT2",
  "LPT3",
  "LPT4",
  "LPT5",
  "LPT6",
  "LPT7",
  "LPT8",
  "LPT9",
]);
const MAX_LENGTH = 255;

function hasControlCharacter(name: string): boolean {
  for (let i = 0; i < name.length; i++) {
    if (name.charCodeAt(i) < 32) return true;
  }
  return false;
}

export interface FileNameValidationResult {
  isValid: boolean;
  error?: string;
}

export interface FileNameValidationOptions {
  disallowExtension?: string;
}

export function validateFileName(
  name: string,
  options: FileNameValidationOptions = {},
): FileNameValidationResult {
  if (name.trim().length === 0) {
    return { isValid: false, error: "Name cannot be empty." };
  }
  if (INVALID_CHARS.some((char) => name.includes(char)) || hasControlCharacter(name)) {
    return { isValid: false, error: 'Name cannot contain: < > : " / \\ | ? *' };
  }
  if (
    options.disallowExtension &&
    name.toLowerCase().endsWith(options.disallowExtension.toLowerCase())
  ) {
    return {
      isValid: false,
      error: `Name cannot end with "${options.disallowExtension}"; the extension is added automatically.`,
    };
  }
  if (name.endsWith(".")) {
    return { isValid: false, error: "Name cannot end with a dot." };
  }
  if (name.length > MAX_LENGTH) {
    return { isValid: false, error: `Name cannot exceed ${MAX_LENGTH} characters.` };
  }
  if (RESERVED_NAMES.has(name.toUpperCase())) {
    return { isValid: false, error: `"${name}" is a reserved system name.` };
  }
  return { isValid: true };
}

export interface SplitFileName {
  baseName: string;
  extension: string;
}

export function splitFileName(fullName: string): SplitFileName {
  const lastDotIndex = fullName.lastIndexOf(".");
  if (lastDotIndex <= 0) {
    return { baseName: fullName, extension: "" };
  }
  return {
    baseName: fullName.slice(0, lastDotIndex),
    extension: fullName.slice(lastDotIndex),
  };
}
